<template>
  <v-footer padless>
    <v-card
      class="flex"
      flat
    >
      <v-card-title>
        <v-btn
          text
          tile
          @click="showHelpDialog"
        >
          Hỗ trợ
        </v-btn>
        <v-btn
          text
          tile
          @click="getDocument"
        >
          Tài liệu sử dụng
        </v-btn>
        <v-spacer/>
        <v-btn
          text
          tile
          @click="showChangeLog()"
        >
          VNPT | Phiên bản 1.3
        </v-btn>
      </v-card-title>
    </v-card>
    <Help
      :showDialog="helpDialog" 
      @cancelled="onHelpCancelled"
    />
    <Changelog 
      :showDialog="changelogDialog"
      @cancelled="onChangelogCancelled"
    />
  </v-footer>
</template>
<script>
  import { mapState } from 'vuex';
  import Help from '@/views/admin/Help';
  import Changelog from '@/views/admin/systems/changelogs/Timeline';
  export default {
    components: {
      Help,
      Changelog
    },
    data() {
      return {
        helpDialog: false,
        changelogDialog: false
      }
    },
    computed: {
      ...mapState([
        'config'
      ])
    },
    methods: {
      getDocument(){
        window.open(
          `${this.config.beUrl}/document/HDSD_KetNoiNongNghiep.pdf`,
          '_blank'
        );
      },
      showHelpDialog(){
        this.helpDialog = true;
      },
      onHelpCancelled () {
        this.helpDialog = false;
      },
      showChangeLog(){
        this.changelogDialog = true;
      },
      onChangelogCancelled () {
        this.changelogDialog = false;
      },
    }
  }
</script>